// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"663":"92476730","845":"92476730","854":"92476730"}[chunkId] + ".chunk.css";
};